import React, { useContext } from 'react';

import { animateScroll as scroll } from 'react-scroll';
import { debounce } from 'lodash';
import Layout from './layout/Layout';
import { OrchestratorContext } from '../contexts/OrchestratorContext';
import { DataContext } from '../contexts/DataContext';
import BotDialogType from '../core/type/dialog/BotDialogType';
import BotDialog from './dialog/BotDialog';
import UserDialog from './dialog/UserDialog';
import TextInputType from '../core/type/input/TextInputType';
import TextInput from './input/TextInput';
import { OptionContext } from '../contexts/OptionContext';
import UserDialogType from '../core/type/dialog/UserDialogType';
import RaterInputType from '../core/type/input/RaterInputType';
import RaterInput from './input/RaterInput';
import ButtonInput from './input/ButtonInput';
import ButtonInputType from '../core/type/input/ButtonInputType';
import SelectorInputType from '../core/type/input/SelectorInputType';
import RadioInput from './input/RadioInput';
import RangeSelectorType from '../core/type/input/RangeSelectorType';
import RangeSelector from './input/RangeSelector';
import SeletorProjetoInput from './input/SeletorProjetoInput';
import SeletorProjetoInputType from '../core/type/input/SeletorProjetoInputType';

const debouncedScroll = debounce((
  shouldScroll,
) => {
  if (shouldScroll) {
    scroll.scrollToBottom();
  } else {
    scroll.scrollMore(250);
  }
}, 250);

const Messenger = () => {
  const optionContext = useContext(OptionContext);
  const orchestratorContext = useContext(OrchestratorContext);
  const dataContext = useContext(DataContext);

  const { setDisplay, displayOptions } = optionContext;
  const { history, next } = orchestratorContext;

  const { data } = dataContext;

  return (
    <Layout>
      {
        history.map((historyItem, i) => {
          const key = `orchestrator-history-${i}`;
          if (historyItem.scroll !== false) {
            debouncedScroll(true);
          } else {
            debouncedScroll(false);
          }

          switch (historyItem.constructor) {
            case BotDialogType:
              setDisplay(displayOptions.input);
              return (
                <BotDialog
                  key={key}
                  data={data}
                  message={historyItem.message}
                  tooltip={historyItem.tooltip}
                  next={next}
                />
              );
            case UserDialogType:
              setDisplay(displayOptions.input);
              return (
                <UserDialog
                  key={key}
                  data={data}
                  message={historyItem.message}
                  next={next}
                />
              );
            case TextInputType:
              setDisplay(displayOptions.input);
              return (
                <TextInput
                  key={key}
                  placeholder={historyItem.placeholder}
                  mask={historyItem.mask}
                  validation={historyItem.validation}
                  next={next}
                  maxSuggestions={historyItem.maxSuggestions}
                  suggestions={data.options[historyItem.suggestionsId]}
                  filtered={historyItem.filtered}
                  minLength={historyItem.minLength}
                  numberMode={historyItem.numberMode}
                  textareaMode={historyItem.textareaMode}
                  optional={historyItem.optional}
                  onSuggestionSubmit={historyItem.onSuggestionSubmit}
                  defaultData={data[historyItem.defaultData]}
                />
              );
            case RaterInputType:
              setDisplay(displayOptions.input);
              return (
                <RaterInput
                  key={key}
                  next={next}
                  options={data.options[historyItem.options]}
                />
              );
            case ButtonInputType:
              setDisplay(displayOptions.input);

              return (
                <ButtonInput
                  key={key}
                  buttons={
                    historyItem.buttons.map((btn) => (
                      { text: btn.text, onClick: () => next(btn), hint: btn.hint, rounded: true }
                    ))
                  }
                />
              );
            case SelectorInputType:
              setDisplay(displayOptions.singleButton);
              return (
                <RadioInput
                  key={key}
                  next={next}
                  options={data.options[historyItem.options]}
                  type={historyItem.typeInput}
                  column={historyItem.column}
                />
              );
            case RangeSelectorType:
              setDisplay(displayOptions.input);
              return (
                <RangeSelector
                  key={key}
                  next={next}
                  options={[]}
                />
              );
            case SeletorProjetoInputType:
              setDisplay(displayOptions.singleButton);
              return (
                <SeletorProjetoInput
                  key={key}
                  next={next}
                />
              );
            default:
              return <div key={key} />;
          }
        })
      }
    </Layout>
  );
};

export default Messenger;
